import { useState } from "react";
import AdbCarousel from "./AdbCarousel";
import {
  adbAccessibilitySteps,
  adbDeveloperModeSteps,
  adbLadbSteps,
  adbLogoutSteps,
  adbSafeApkInstallationSteps,
} from "../data/landingData";

export default function ActivationSection() {
  const [activeTab, setActiveTab] = useState("pc");

  return (
    <section id="tutorial" className="section activation">
      <h2 className="section-title">Tutoriels d&apos;activation</h2>
      <p className="section-subtitle">
        Choisissez la méthode qui vous convient pour obtenir l&apos;autonomie
        système de SAFE.
      </p>
      <div className="activation-tabs">
        <button
          type="button"
          className={`tab ${activeTab === "pc" ? "active" : ""}`}
          onClick={() => setActiveTab("pc")}
        >
          Activation via PC
        </button>
        <button
          type="button"
          className={`tab ${activeTab === "phone" ? "active" : ""}`}
          onClick={() => setActiveTab("phone")}
        >
          Activation via téléphone (ADB)
        </button>
      </div>
      <div className="activation-content">
        {activeTab === "pc" && (
          <div className="adb-phone-steps">
            <div className="steps-grid adb-phone-steps-grid">
              <div className="step-card">
                <span className="step-num">01</span>
                <h3 className="step-title">
                  Installation de l&apos;APK (sécurité, Play Protect,
                  permissions)
                </h3>
                <AdbCarousel
                  items={adbSafeApkInstallationSteps}
                  imagesDir="safe_apk_installation"
                />
              </div>

              <div className="step-card">
                <span className="step-num">02</span>
                <h3 className="step-title">
                  Déconnexion des comptes (Samsung / Google)
                </h3>
                <AdbCarousel items={adbLogoutSteps} imagesDir="google_logout" />
              </div>

              <div className="step-card">
                <span className="step-num">03</span>
                <h3 className="step-title">Mode développeur & Débogage USB</h3>
                <AdbCarousel
                  items={adbDeveloperModeSteps}
                  imagesDir="dev_and_debug_mode"
                />
              </div>

              <div className="step-card">
                <span className="step-num">04</span>
                <h3 className="step-title">Activation du Device Owner</h3>
                <div className="pc-terminal-step">
                  <p>
                    Connectez l&apos;appareil à votre PC. Téléchargez et
                    exécutez le fichier suivant pour finaliser l&apos;activation
                    :
                  </p>
                  <div className="download-action">
                    <a
                      href="/others/sdo.bat"
                      download="sdo.bat"
                      className="download-btn"
                    >
                      <span className="btn-icon">📥</span>
                      Télécharger sdo.bat
                    </a>
                  </div>
                  <p className="step-sub-instruction">
                    Une fois téléchargé, faites un clic droit sur le fichier et
                    choisissez &quot;Exécuter en tant qu&apos;administrateur&quot;.
                  </p>
                </div>
              </div>
            </div>
            <p className="activation-warning">
              ⚠️ Réinitialiser l&apos;appareil ou désinstaller SAFE supprimera le
              mode propriétaire ; vous devrez réactiver après réinstallation.
            </p>
          </div>
        )}
        {activeTab === "phone" && (
          <div className="adb-phone-steps">
            <div className="steps-grid adb-phone-steps-grid">
              <div className="step-card">
                <span className="step-num">01</span>
                <h3 className="step-title">
                  Installation de l&apos;APK (sécurité, Play Protect,
                  permissions)
                </h3>
                <AdbCarousel
                  items={adbSafeApkInstallationSteps}
                  imagesDir="safe_apk_installation"
                />
              </div>

              <div className="step-card">
                <span className="step-num">02</span>
                <h3 className="step-title">
                  Déconnexion des comptes (Samsung / Google)
                </h3>
                <AdbCarousel items={adbLogoutSteps} imagesDir="google_logout" />
              </div>

              <div className="step-card">
                <span className="step-num">03</span>
                <h3 className="step-title">
                  Mode développeur, sécurité & débogage USB
                </h3>
                <AdbCarousel
                  items={adbDeveloperModeSteps}
                  imagesDir="dev_and_debug_mode"
                />
              </div>

              <div className="step-card">
                <span className="step-num">04</span>
                <h3 className="step-title">
                  Configuration Accessibilité & activation SAFE
                </h3>
                <AdbCarousel
                  items={adbAccessibilitySteps}
                  imagesDir="safe_launch"
                />
              </div>

              <div className="step-card">
                <span className="step-num">05</span>
                <h3 className="step-title">
                  Configuration LADB (connexion + Device Owner)
                </h3>
                <AdbCarousel items={adbLadbSteps} imagesDir="ladb_connexion" />
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
